import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  flex-grow: 1;\n  flex-shrink: 1;\n  /* allowing the container to collapse down to its min width */\n  min-width: ', 'px;\n  ', ' display: flex;\n'], ['\n  flex-grow: 1;\n  flex-shrink: 1;\n  /* allowing the container to collapse down to its min width */\n  min-width: ', 'px;\n  ', ' display: flex;\n']);

import styled from 'styled-components';
import { containerClosedWidth } from '../../shared-variables';
import { isElectronMac } from '../../theme/util';

var getTransform = function getTransform(_ref) {
  var horizontalOffset = _ref.horizontalOffset;

  if (!horizontalOffset || horizontalOffset === 0) {
    return '';
  }
  return 'transform: translateX(' + horizontalOffset + 'px);';
};

var NavigationContainerNavigationWrapper = styled.div(_templateObject, function (props) {
  return containerClosedWidth(isElectronMac(props.theme));
}, getTransform);

NavigationContainerNavigationWrapper.displayName = 'NavigationContainerNavigationWrapper';

export default NavigationContainerNavigationWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/NavigationContainerNavigationWrapper.js
// module id = 613
// module chunks = 0